<template>
    <section class="login-now" loding="lazy" @click="closeCountryCodeOnOutsideClick">
        <div class="loginInner1" v-if="siteSettings">
            <div class="log-logo">
                <img loading="lazy" :src="siteSettings?.aws_url + siteSettings?.storage_path.domain_image + siteSettings?.logo"
                    alt="logo">
            </div>
            <div class="featured-box-login">
                <h1>{{ $t('log-in','Login')}} <i class="fas fa-hand-point-down"></i></h1>
                <form class="form-control-head">
                    <div class="login-tab-sec">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist" v-if="siteSettings?.business_type == 2">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" :class="form.type == 1 ? 'active': ''" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#phone-num" type="button" role="tab"
                                    aria-controls="phone-num" aria-selected="true" @click="chooseFormType('1')">{{ $t('mobile-number','Mobile Number')}}</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" :class="form.type == 2 ? 'active': ''" id="user-id-tab" data-bs-toggle="pill" data-bs-target="#user-id" type="button" role="tab"
                                    aria-controls="user-id" aria-selected="false" @click="chooseFormType('2')">{{ $t('user-id','User ID')}}</button>
                            </li>
                        </ul>
                        <div class="tab-content" id="pills-tabContent" v-if="siteSettings?.business_type == 2">

                            <div class="tab-pane fade" :class="form.type == 1 ? 'show active': ''" id="phone-num" role="tabpanel" aria-labelledby="phone-num-tab">
                                
                                <div class="input-field">
                                    <div class="country-mob">
                                        <div class="form_list_select">
                                            <div class="country-select-card" ref="countryCodeWrapper">
                                                <div class="country-select" v-if="countryCodeList && countryCodeList[contIndex]" @click="openCountryCode()" :class="{ 'disabled': timerRunning }">
                                                    <div class="country-icon">
                                                        <img :src="countryCodeList[contIndex]?.flag" alt="India" loading="lazy">
                                                    </div>
                                                    <div class="country-code">+  {{ countryCodeList[contIndex]?.phonecode }}</div>
                                                    <span class="arrowDown"></span>
                                                </div> 
                                                <div class="country-dropdown" :class="checkCountryCodeSelect ? 'open' :''">
                                                    <div class="country-list">
                                                        <template v-for="(allowedCountry, countryIndex) in countryCodeList">
                                                            <div class="country-item" :key="countryIndex"
                                                                v-if="allowedCountry?.phonecode != countryCodeList[contIndex]?.phonecode"
                                                                @click="selectCountryCode(countryIndex,allowedCountry?.phonecode)">
                                                                <div class="country-icon">
                                                                    <img :src="allowedCountry?.flag" :alt="allowedCountry.name" loading="lazy">
                                                                </div>
                                                                <div class="country-name">{{ allowedCountry.name }}</div>
                                                                <div class="country-code">+{{ allowedCountry.phonecode }}</div>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form_list_select_div-r">
                                                <input type="tel" class="form-control" :placeholder="$t('enter-phone-number', 'Enter Mobile Number')+'*'" 
                                                    @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo,9999999999)" 
                                                    id="phonenumber" v-model="form.mobileNo" minlength="10" maxlength="10" :disabled="resendOtp && timerRunning">
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="init && checkValidation?.mobile?.length > 0" class="thm-error-text">
                                        <div v-for="(err, index) in checkValidation?.mobile" :key="index">
                                            <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                        </div>
                                    </div>
                                    <div v-if="init && form.mobileNo.length == 10 && !timerRunning && loginMethod == 'otp'" class="thm-error-text">
                                        <div>
                                            <p class="error-text">{{$t('please-click-on-send-otp','Please Click on Get OTP')}}</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="login-method-section">
                                    <div class="label-tabs">
                                        <input class="form-check-input flexRadioDefault-sec" @click="clearOTPPassword()" type="radio" name="login-method" id="login-password" value="password" v-model="loginMethod">
                                        <label for="login-password">{{$t('password','Password')}}</label>
                                    </div>
                                    <div class="label-tabs">
                                        <input class="form-check-input flexRadioDefault-sec" @click="clearOTPPassword()" type="radio" name="login-method" id="login-otp" value="otp" v-model="loginMethod">
                                        <label for="login-otp">{{$t('otp','OTP')}}</label>
                                    </div>
                                </div>                                
                            </div>
                            <div class="tab-pane fade" :class="form.type == 2 ? 'show active': ''" id="user-id" role="tabpanel" aria-labelledby="user-id-tab">
                                <div class="input-field">
                                    <div class="input-field-group">
                                        <input type="text" maxlength="25" class="form-control" id="inputPassword2" @input="form.userId = $helper.sanitizeDetails('signUpUserId', form.userId)"
                                        :placeholder="$t('user-id','Enter User ID')+'*'" v-model="form.userId" />
                                        <div class="input-group-icon"><i class="fas fa-user"></i></div>
                                    </div>
                                    <div v-if="init && checkValidation?.userId?.length > 0" class="thm-error-text">
                                        <span v-for="(err, index) in checkValidation?.userId" :key="index">
                                            <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-content" id="pills-tabContent" v-else>
                            <div class="tab-pane fade show active" id="user-id" role="tabpanel" aria-labelledby="user-id-tab">
                                <div class="user-password-wrapper">
                                    <div class="password-box input-field for">
                                        <input type="text" class="form-control" @input="form.userId = $helper.sanitizeDetails('oldLoginUserId', form.userId);"
                                        :placeholder="$t('user-id','User ID')+'*'" v-model="form.userId">
                                        <div class="inp-img">
                                            <img loading="lazy" src="@/assets/images/user-login-icons.webp" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div v-if="init && checkValidation?.userId?.length > 0" class="error-message-box mt-2">
                                    <span v-for="(err, index) in checkValidation?.userId" :key="index">
                                        <p class="wrong-message">{{ $t(err.lang, err.error) }}</p>
                                    </span>                                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="input-field">
                        <div class="input-field-group"  v-if="loginMethod == 'password'">
                            <input :type="passwordFieldType" maxlength="20" class="form-control" id="inputPassword4" @input="form.password = $helper.sanitizeDetails('password', form.password, 999999)"
                            :placeholder="$t('enter-password','Enter Password')+'*'" v-model="form.password" />
                            <div class="showHide-icon" @click="togglePasswordVisibility('passwordFieldType')">
                                <i v-if="passwordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                <i v-else aria-hidden="true" class="fa fa-eye"></i>
                            </div>
                        </div>
                        <div class="input-field-group" v-if="loginMethod == 'otp'">
                            <input type="tel" class="form-control" id="inputPassword2" @input="form.password = $helper.sanitizeNumber(form.password, 999999)"
                            :placeholder="$t('enter-otp','Enter OTP')+'*'" v-model="form.password" maxlength="6" />
                            <div class="mak-gin">
                                <button v-if="!loadingOtp" :disabled="timerRunning" type="button" id="otp-btn" class="sendOtp-btn" :class="{ 'otp-btn' : (!timerRunning && !resendOtp), 'resend-btn' : (!timerRunning && resendOtp) }" @click="sendOtpServiceCall()">
                                    {{ isOtpApiCalled && (minutes > 0 || seconds > 0) ? formatTime(minutes) + ':' + formatTime(seconds) : (resendOtp ? $t('resend-otp','RESEND OTP') : $t('get-otp','GET OTP')) }}
                                </button>
                                <div v-if="loadingOtp" class="text-center" id="Otp_loader">
                                    <div class="spinner-border" role="status">
                                        <span class="visually-hidden">{{ $t('loading','Loading')}}...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="showValidationError && form.password == ''" class="thm-error-text">
                            <span>
                                <p class="error-text">{{ $t(`please-enter-${loginMethod.toLowerCase()}`,`Please Enter ${loginMethod == 'password' ? $t('password','Password') : $t('otp','OTP')}.`)}}</p>
                            </span>
                        </div>
                        <div v-if="form.password.length > 0 && form.password.length < 6 && loginMethod == 'otp' && showValidationError" class="thm-error-text">
                            <span>
                                <p class="error-text">{{ $t('otp-6-digit-msg','Please Enter 6 Digit OTP')}}</p>
                            </span>
                        </div>
                        <div v-if="init.userId && checkValidation?.password?.length > 0 && loginMethod == 'password'" class="thm-error-text">
                            <span v-for="(err, index) in checkValidation?.password" :key="index">
                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                            </span>
                        </div>
                    </div>
                    <div class="forget-sec" v-if="siteSettings && siteSettings?.business_type == 2">
                        <router-link @click="refreshData" :to="{ name: 'ForgetPassword' }">
                            {{ $t('forgot-password','Forgot Password?') }}
                        </router-link>
                    </div>

                    <div class="login-btn-option">
                        <div class="form-group">
                            <a href="JAvascript:void(0);" @click="demoUserLogin()"
                                class="btn btn-submit btn-login">
                                {{ $t('demo-login','Login with Demo')}}
                                <i class="ml-2 fas fa-sign-in-alt"></i>
                            </a>
                        </div>

                        <div class="form-group">
                            <a href="JAvascript:void(0);" @click="signInMethodCall()"
                                class="btn btn-submit btn-login">
                                {{ $t('log-in','Login')}}
                                <i class="ml-2 fas fa-sign-in-alt"></i>
                            </a>
                        </div>
                    </div>

                    <template v-if="siteSettings?.business_type == 2 && siteSettings?.social_link?.whatsappno1">
                        <div class="whats-app" v-if="siteSettings?.social_link?.whatsappno1">
                            <h3 class="whats-with">
                                <span class="whats-with-now">
                                    {{ $t('get-your-ready-made-id-from-whatsapp',"Get your ready-made ID from whatsapp")}}
                                </span>
                            </h3>
                            <div class="button-whatsapp">
                                <button class="btn-whatsapp" @click.prevent="openWhatsApp()" type="button">
                                    <img loading="lazy" src="@/assets/images/whatsapp.webp" alt="" />
                                    <span class="blinking">{{ $t('whatsapp-now',"WhatsApp Now")}}</span></button>
                            </div>
                        </div>
                    </template> 

                    <div class="other-login-option" v-if="siteSettings && siteSettings?.business_type == 2 && siteSettings?.social_link && (siteSettings.social_link?.facebook_link || siteSettings.social_link?.instagram_link 
                        || siteSettings.social_link?.telegram_link || siteSettings.social_link?.twitter_link)">
                        <h3>{{ $t('or-login-with','Or Login With')}}</h3>
                        <ul class="login-by-social-icon">
                            <li v-if="siteSettings.social_link?.facebook_link">
                                <a :href="siteSettings.social_link?.facebook_link" target="_blank">
                                    <img loading="lazy" src="@/assets/images/facebook-social.svg" alt="">
                                </a>
                            </li>
                            <li v-if="siteSettings.social_link?.instagram_link">
                                <a :href="siteSettings.social_link?.instagram_link" target="_blank">
                                    <img loading="lazy" src="@/assets/images/instagram-social.svg" alt="">
                                </a>
                            </li>
                            <li v-if="siteSettings.social_link?.telegram_link">
                                <a :href="siteSettings.social_link?.telegram_link" target="_blank">
                                    <img loading="lazy" src="@/assets/images/telegram-social.svg" alt="">
                                </a>
                            </li>
                            <li v-if="siteSettings.social_link?.twitter_link">
                                <a :href="siteSettings.social_link?.twitter_link" target="_blank">
                                    <img loading="lazy" src="@/assets/images/twitter-social.svg" alt="">
                                </a>
                            </li>
                            <!-- <li>
                                <a href="">
                                    <img loading="lazy" src="@/assets/images/google.webp" alt="">
                                </a>
                            </li> -->
                        </ul>
                    </div>
                    
                    <template v-if="siteSettings?.business_type == 2">
                        <p class="whats-with-acc">{{ $t('dont-have-an-account',"Don’t Have An account?")}} &nbsp;
                            <router-link :to="{ name: 'SignUp' }" @click="refreshData">{{ $t('register','Register')}}</router-link>
                        </p>
                    </template>
                    
                </form>
            </div>
        </div>
    </section>
</template>

<script>
import { AUTH_TOKEN } from '@/shared/constants/cookies-const';
import axios from 'axios';
import { mapGetters } from 'vuex';
import { setHeaders } from '@/shared/services/headers';
import validate from '../services/authValidation';
import commonAuth from '@/modules/authorization/services/commonAuth';

export default {
    name: "Login",
    extends: commonAuth,
    data() {
        return {
            form: {
                code: 91,
                mobileNo: "",
                userId: "",
                password: "",
                type: 1
            },
            inputvalue: [
                {
                value: 100,
                },
                {
                value: 500,
                },
                {
                value: 1000,
                },
                {
                value: 2000,
                },
            ],
            loading: false,
            demoLoading: false,
            showValidationError: false,
            passwordFieldType: 'password',
            loginMethod: 'password',
            validationErrors : null,
            isOtpApiCalled: false,
            init: false,
            checkCountryCodeSelect:false,
            defaultCountryCode : this.$store?.getters?.siteSettings?.country_code,
            loggedUserCheck: null,
        };
    },
    computed: {
        ...mapGetters({
            siteSettings: 'siteSettings'
        }),
        checkValidation() {
            const validationErrors = validate.areFieldsValid(
                'login', 
                this.form.type, 
                this.form.mobileNo, 
                this.form.userId, 
                this.form.password
            );
            if(this.init){
                return validationErrors;
            }
        },
        countryCodeList(){
            return this.$store?.getters?.siteSettings?.country_code_list;
        },
    },
    mounted() {
        this.loggedUserCheck = localStorage.getItem("LoggedUser");
        this.contIndex =  this.countryCodeList?.findIndex(ci => ci.phonecode == this.defaultCountryCode)
        if(localStorage.getItem('login_type') && this.siteSettings?.business_type == 2) {
            this.form.type = localStorage.getItem('login_type');
        }
    },
    methods: {
        clearOTPPassword(){
            this.form.password = '';
        },
        closeCountryCodeOnOutsideClick(event) {
            const countryCodeElement = this.$refs.countryCodeWrapper;
            // const countryCodeElement = this.$el.querySelector('.country-code-flag-top-wrapper');
            if (countryCodeElement && event && event.target && !countryCodeElement.contains(event.target)) {
                this.checkCountryCodeSelect = false;
            }
        },
         selectCountryCode(code,phone_code){
            this.contIndex = code;
            this.form.code = parseInt(phone_code)
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        openCountryCode(){
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        togglePasswordVisibility() {            
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';            
        },
        openWhatsApp() {
            window.open(`//wa.me/${this.siteSettings.social_link.whatsappno1}`, '_blank');
        },
        demoUserLogin() {
            this.form.type = 1;
            this.form.userId = "demouser";
            this.form.password = "demopass";
            this.loginServiceCall('DEMO_LOGIN_API', 'demo')
        },
        signInMethodCall() {
            this.init = true;
            let id = this.getId();
            if (id == "" || this.form.password == "") {
                this.showValidationError = true;
            }
            else{    
                if(this.loginMethod == 'otp'){
                    if(this.isOtpApiCalled)
                        this.signInWithOtp()
                }
                else{
                    this.loginServiceCall('LOGIN_API', 'nondemo');
                }
            }
        },
        async loginServiceCall(url,type) {
            if (type == 'demo') {
                this.demoLoading = true;
            } else {
                this.loading = true;
            }
            let id = this.getId();
            let data = {
                "userid": id.toString(),
                "type": this.siteSettings?.business_type == 1 ? 2 : this.form.type,
                "password": this.form.password,
                "cncode": this.form.code,
            };
            this.$apiCall('post', url, data).then(response => {
                type == 'demo' ? this.demoLoading = false : this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            this.$successToast(response.data.message);
                            let userData = response.data.data;
                            if(this.loggedUserCheck!=userData.userid){
                                this.$store.dispatch('setClickBetValue',this.inputvalue);
                            }
                            this.$cookies.set(AUTH_TOKEN, userData.token);
                            this.$store.dispatch('setToken', `Bearer ${userData.token}`);
                            window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                            localStorage.setItem('login_type', data.type)
                            localStorage.setItem("LoggedUser",userData.userid)
                            setHeaders();
                            if(type == 'demo'){
                                userData.demo = true;
                            }
                            this.setUserDataToStore(userData);
                            // Userid and offer-----------------------------------------------------------
                            this.setUserIdsToStore(userData?.userid,userData?.last_login_at)
                            // ---------------------------------------------------------------------------
                            this.refreshData();
                            this.$router.push('/home');
                            setTimeout(()=>{
                                window.location.reload();
                            },500)
                        }
                    }
                }
            }).catch(error => {
                type == 'demo' ? this.demoLoading = false : this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        chooseFormType(formType) {
            this.form.type !== formType && this.refreshData();
            this.form.type = formType;
            this.loginMethod = "password";
        },
        signInWithOtp() {
            let id = this.getId();
            this.loading = true;
            let data = {
                mobile: id,
                countrycode: this.form.code,
                otp: this.form.password
            };
            this.$apiCall('post','LOGIN_WITH_OTP', data).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        } else {
                        
                            this.$successToast(response.data.message);
                            let userData = response.data.data;
                            if(this.loggedUserCheck!=userData.userid){
                                this.$store.dispatch('setClickBetValue',this.inputvalue);
                            }
                            this.$cookies.set(AUTH_TOKEN, userData.token);
                            this.$store.dispatch('setToken', `Bearer ${userData.token}`);
                            window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                            //for add on all APIs
                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                            setHeaders();
                            this.setUserDataToStore(userData);
                            // Userid and offer-----------------------------------------------------------
                            this.setUserIdsToStore(userData?.userid,userData?.last_login_at)
                            // ---------------------------------------------------------------------------
                            localStorage.setItem("LoggedUser",userData.userid)
                            this.refreshData();
                            this.$router.push({ name: 'Sports' });
                            setTimeout(()=>{
                                window.location.reload();
                            },500)
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        getId() {
            if (this.siteSettings?.business_type == 2) {
                return this.form.type == 1 ? this.form.mobileNo : this.form.userId;
            } else {
                this.form.type = 2;
                return this.form.userId;
            }
        },
        setUserDataToStore(userData) {
            let asciiCodes = null;
            for (let i = 0; i < userData.userid.length; i++) {
                asciiCodes += userData.userid.charCodeAt(i)
            }
            let user = {
                balance: userData.balance,
                currency: userData.currency,
                currency_slug: userData.currency_slug,
                last_login_at: userData.last_login_at,
                name: userData.name,
                rid: userData.rid,
                userid: userData.userid,
                exposure: userData.expl,
                available_credits: userData.available_credits,
                asciiCodes: asciiCodes,
                id: userData.id,
                exp: userData.exp,
                activeWallet: userData.actw,
                cpi:userData.cpi,
                notificationSubscribed:null,
                notificationUnsubscribed:null,
                isDemo: userData?.demo || false
            }
            this.$store.dispatch('setUser', user);
            this.$store.dispatch('setChips', userData.chips);
            this.$store.dispatch('setEventManage', userData.lock_settings);
        },
        // Userid and offer-----------------------------------------------------------
        setUserIdsToStore(userId,last_login) {
            let oldUserIds = this.$store.getters?.logInData?.userIds || [];
            if(this.form.type == 2) {
                if(last_login){
                    oldUserIds.push(userId);
                }
                let data = {
                    logInWithMobile: false,
                    userIds: oldUserIds
                }
                this.$store.dispatch('setLogInData', data);
            }
            else {
                let data = {
                    logInWithMobile: true,
                    userIds: oldUserIds
                }
                this.$store.dispatch('setLogInData', data);
            }
        },
        // ---------------------------------------------------------------------------
    },
};
</script>

<style>form {
    margin-block-end: 1em;
}

.form-control.add::-webkit-inner-spin-button {
    display: none;
}</style>